import isEmpty from "lodash/isEmpty"
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters('actingUser', ['isUserAllowedToSeeModule']),
  },
  methods: {
    filterOnlyVisibleModules(modules) {
      return modules.filter(item => item.hidden === undefined || item.hidden === false);
    },    
    removeEmptyModuleCluster(modules) {
      return modules.filter((_module) => {
        return isEmpty(_module.items) === false;
      });
    },
    mapItems(childrenModules) {
      return childrenModules.map(child => ({
        id: child.id,
        label: child.label,
        image: child.navigationImg,
        routerLink: child.routerLink
      }));
    },
    filterOnlyModulesUserIsAllowedToSee(modules) {
      return modules.filter((_module) => {
        return this.isUserAllowedToSeeModule(_module.id)
      });
    },
  }
}
